import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import 'payment-calculator/components/ResidualValue/ResidualValue.scss';

const ResidualValue = ({ residualValue }) => {
    if (!residualValue || residualValue < 0) {
        return null;
    }

    return (
        <div className="section-residual">
            <div className="sr-paymentCalculator-EmphasisColor">
                <span className="label"> {LocaleService.t('PAYMENT_CALCULATOR.KMPLANS.BUY_BACK_VALUE')} </span>
                <span className="value">
                    <PriceAmounts price={LocaleService.l(residualValue, CurrencyFormats.CURRENCY_0)} />
                </span>
            </div>
        </div>
    );
};

ResidualValue.propTypes = {
    residualValue: PropTypes.number.isRequired,
};

ResidualValue.displayName = 'ResidualValue';

export default ResidualValue;
